<template>
  <div class="t-code" v-if="body_show">
    <!-- 班主任微信 -->
    <div class="code-box">
      <img :src="code" alt="">
      <h2>长按识别并添加班主任微信</h2>
      <h3>班主任会在48小时内通过好友验证，<br/>
按照添加顺序排班上课</h3>
    </div>
    <img src="@a/code_b.png" class="code_img" alt="" />
    <!-- 按钮 -->
    <a class="view-details-btn" @click="card_show=true">立即邀请好友</a>
    <router-link v-if="data.info.info" class="edit-info-btn" :to="{
                path:'/training_information',
                query:{
                    course_id:this.$route.query.course_id
                }
            }">修改资料</router-link>
    <div class="pop_img" v-show="card_show" @click="card_show=false"></div>
  </div>
</template>
<script>
import {
  getQrcode
} from "@/api/training";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        code: '',
        type_obj: {},
        card_show: false,
        data: {}
      }
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        getQrcode({
          course_id: this.$route.query.course_id
        }).then((data) => {
          this.$toast.clear();
          if (data.code && data.code === 10002) {
            this.$toast(data.data.msg);
            this.$router.push({
              path: "/training_details",
              query: {
                course_id: this.$route.query.course_id
              }
            })
            return;
          }
          this.code = data.info.course.qrcode;
          this.body_show = true;
          this.data = data;
          this.type_obj = {
              nickname: data.user.nickname,
              train_name: data.info.course.name,
              train_id: data.info.course.id,
              share: data.user.id
            };
          shareCon("training", this, this.type_obj);
        })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.t-code {
  padding: 60px 86px 98px;
  background-color: #ffffff;
  .code-box {
    border: 2px solid rgba(204, 204, 204, 1);
    border-radius: 8px;
    padding: 32px 74px 37px;
    img {
      width: 100%;
    }
    h2 {
      text-align: center;
      font-size: 30px;
      color: #EB5032;
      font-weight: 500;
    }
    h3 {
      color: #999;
      font-size: 24px;
      line-height: 36px;
      margin-top: 10px;
      text-align: center;
    }
  }
  .view-details-btn {
    display: block;
    text-align: center;
    border: 2px solid #EB5032;
    width: 100%;
    line-height: 80px;
    background: #EB5032;
    color: #ffffff;
    font-size: 34px;
    border-radius: 8px;
    margin: 35px auto 30px;
  }
  .edit-info-btn {
    text-align: center;
    display: block;
    width: 100%;
    line-height: 80px;
    border: 2px solid #EB5032;
    border-radius: 8px;
    background-color: #ffffff;
    font-size: 34px;
    color: #EB5032;
  }
}
.code_img {
  width: 100%;
  margin-top: 30px;
}
.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}
</style>
